// MsalProvider.tsx

import React, { useEffect, useState } from 'react';
import * as msal from '@azure/msal-browser';
import { CenterComponent } from '../components/common/CenterComponent';
import { Spinner, SpinnerSize } from '@fluentui/react';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from '../helpers/LogginHelper';
import { IsVerbose } from '../helpers/Console';

interface MsalAuthProviderProps {
  children: React.ReactNode; // Add this prop
}

const MsalAuthProvider: React.FC<MsalAuthProviderProps> = ({ children }) => {
  const [initialized, setInitialized] = useState(false);
  const [localPca, setLocalPca] = useState<msal.IPublicClientApplication | null>(null);

  useEffect(() => {
    // Initialize MSAL and handle any redirect responses from authentication
    const initializePca = async () => {
      try {
        const pcaInstance = await msal.createNestablePublicClientApplication(msalConfig());

        // Handle redirect promise to complete authentication flow on page reload
        // This is crucial for silent token acquisition after page refresh
        const response = await pcaInstance.handleRedirectPromise();

        // If returning from a loginRedirect, store the granted scopes
        if (response?.scopes) {
          localStorage.setItem('scp', JSON.stringify(response.scopes));
          IsVerbose() && console.log('✅ Redirect login completed, scopes stored');
        }

        setLocalPca(pcaInstance);
        setInitialized(true);
        IsVerbose() && console.log('✅ MSAL initialized and ready for silent token acquisition');
      } catch (error) {
        console.error('❌ Failed to initialize MSAL:', error);
        setInitialized(true); // Still set to true to avoid infinite loading
      }
    };

    initializePca();
  }, []);

  if (!initialized) return (
    <CenterComponent>
      <Spinner className='spinner' size={SpinnerSize.large} label='Initializing...' />
    </CenterComponent>
  );

  return (
    <MsalProvider instance={localPca!}>
      {children}
    </MsalProvider>
  );
};

export default MsalAuthProvider;
